import createInstance from '../http';
import config from '@/const/config';
const { request } = createInstance(config.cartBaseUrl);

export default {
  showCart: params => request.post(`/api/share-mall-gateway-cart/1.0.0/showCart`, params), // 购物车展示
  addOrUpdateCart: (params, config) =>
    request.post(`/api/share-mall-gateway-cart/1.0.0/addOrUpdateCart`, params, config), // 加入购物车
  batchAddCart: (params, config) => request.post(`/api/share-mall-gateway-cart/1.0.0/batchAddCart`, params, config), // 复购、再来一单
  deleteCart: params => request.post(`/api/share-mall-gateway-cart/1.0.0/deleteCart`, params), // 商品删除
  deleteInvalidGoods: params => request.post(`/api/share-mall-gateway-cart/1.0.0/deleteInvalidGoods`, params), // 失效商品一键删除
  queryCartItemNum: params =>
    request.get(`/api/share-mall-gateway-cart/1.0.0/queryCartItemNum`, { ...params, handleError: true }), // 查询购物车数量
  queryPurchaseRestrictionsInformation: params =>
    request.post(`/api/share-mall-gateway-cart/1.0.0/queryPurchaseRestrictionsInformation`, params), // 查询商品购买限制信息接口
  calculatePriceInTime: (params, config) =>
    request.post(`/api/share-mall-gateway-cart/1.0.0/calculatePriceInTime`, params, config) // 实时计算价格
};
